import { Grid, GridProps } from '@dmc/ui/tables';
import { useGridController } from './useGridController';
import { useTranslation } from 'react-i18next';

export interface GridControlledProps<TRow extends object>
  extends Omit<GridProps<TRow>, 'loadingMessage' | 'noRowsMessage'>,
    Partial<Pick<GridProps<TRow>, 'loadingMessage' | 'noRowsMessage'>> {}

export function GridControlled<TRow extends object>(props: GridControlledProps<TRow>) {
  const { t } = useTranslation();

  return (
    <Grid<TRow>
      loadingMessage={t('Loading')}
      noRowsMessage={t('No data')}
      {...props}
      useGridController={useGridController}
    />
  );
}
